import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {TranslateService} from "@ngx-translate/core";
import {appConfig} from '../../app.config';
import {UserService} from '../../services/user.service';
import {Router} from '@angular/router';
import {SharedService} from "../../services/SharedService.service";
import {UserSettingsComponent} from "../user-settings";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {BranchesListComponent} from "../branches-list";
import {YearsListComponent} from "../years-list";
import {Favorites} from "../../model/favorites";
import {DepartmentsListComponent} from '../departments-list';
import {YearService} from "../../views/setting/years/year.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html',
  providers: [SharedService]
})
export class AppSidebarComponent implements OnInit, AfterViewInit {
  languages: any[];
  activelang: any;
  LoginUser: any;
  fav: any;
  public imgUrl = appConfig.publicUrl;
  public screens: any[] = [];
  public systemscreens: any[] = [];
  public branch_id: any;
  public year: any;
  public department_id: any;
  public allscreens: any[] = [];
  private openSystem: string = '';
  private menuparts: any[] = [];
  public userRoles: any[]=[];
  @Input() isShow = true;

  constructor(private sharedService: SharedService,
              private authenticationService: AuthenticationService,
              private modalService: NgbModal,
              public translate: TranslateService,
              private userService: UserService,
              private YearService:YearService,
              private router: Router) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if(localStorage.getItem('showMenu')) {
      const showMenu = JSON.parse(localStorage.getItem('showMenu'));
      this.isShow = showMenu;
    }
    this.screens = currentUser.screens;
    this.branch_id = currentUser.branch_id;
    this.year = currentUser.year;
    this.department_id = currentUser.department_id;
    this.getscreens();
  }

  permission_rd_Allow(Osystem:any):boolean {
    let role:string = '';
    if(Osystem == 'years')
      role = 'showoldyear';
    else if(Osystem == "branches")
      role = 'showrecbranch';
    else
      return false;
    if(this.userRoles.indexOf('setting.'+Osystem+'.'+role) >= 0 || this.userRoles.indexOf('customers.'+Osystem+'.'+role) >= 0) {
      return true;
    }
    return false;
  }


  ngAfterViewInit() {
    if(localStorage.getItem('showMenu')) {
      const showMenu = JSON.parse(localStorage.getItem('showMenu'));
      this.isShow = showMenu;
    }
    this.getsystem();
  }

  changeBranch() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if(currentUser){
      this.branch_id = currentUser.branch_id;
      this.userService.getUserBranDep(this.branch_id).subscribe(
        data => {
          this.department_id = data.main;
          currentUser.department_id = this.department_id;
          let array:any;
          array = {'department_id': this.department_id};

          this.YearService.switchYear(array).subscribe(
              data=>{
                  // console.log('data ---> ', data);
              }
          );
          localStorage.setItem('currentUser', JSON.stringify(currentUser));
        }
      );
    }
  }

  changeYear() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if(currentUser){
      this.year = currentUser.year;
    }
  }

  changeDepartment() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if(currentUser){
      this.department_id = currentUser.department_id;
    }
  }

  getscreens() {
    const allpermissions = JSON.parse(localStorage.getItem('allpermissions'));
    if(allpermissions) {
      this.allscreens = allpermissions.screens;
    } else {
      this.userService.allpermission().subscribe(
        permissions => {
          localStorage.setItem('allpermissions',JSON.stringify(permissions));
          this.allscreens = permissions.screens;
        }, error => {
          console.log(error);
        }
      );
    }

  }

  branches_list() {
    const options: NgbModalOptions = {
      beforeDismiss: () => {
        this.changeBranch();
        return true;
      }
    };
    const modalRef = this.modalService.open(BranchesListComponent, options);
    modalRef.componentInstance.refShow = "";
    modalRef.componentInstance.rowId = '';
  }


  department_list() {
    const options: NgbModalOptions = {
      beforeDismiss: () => {
        this.changeDepartment();
        return true;
      }
    };
    const modalRef = this.modalService.open(DepartmentsListComponent, options);
    modalRef.componentInstance.refShow = "";
    modalRef.componentInstance.rowId = '';
    modalRef.componentInstance.branch_id = this.branch_id;
  }

  years_list() {
    if(this.permission_rd_Allow('years')){
      const options: NgbModalOptions = {
        beforeDismiss: () => {
          this.changeYear();
          return true;
        }
      };
      const modalRef = this.modalService.open(YearsListComponent, options);
      modalRef.componentInstance.refShow = "";
      modalRef.componentInstance.rowId = '';
    }
  }

  routelink(link: string, code: string) {
    if(link === 'general') {
      return;
    }
    this.router.navigate(['./' + link]);

    let screen = {link, code};
    localStorage.setItem('current_screen', JSON.stringify(screen));

  }

  openmenu(key:any) {
    this.systemscreens.forEach(function (eachObj) {
      if(eachObj.id === key) {
        this.menuparts[eachObj.id] = false;
      } else {
        this.menuparts[eachObj.id] = true;
      }
    },this);

  }

  getsystem() {
    //console.log(this.openSystem,localStorage.getItem('OpenSystem'));
    if(this.openSystem !== localStorage.getItem('OpenSystem') && !this.menuparts.length ) {
      this.openSystem = localStorage.getItem('OpenSystem');
      const sysscreens = JSON.parse(localStorage.getItem('menu'+this.openSystem));
      if(sysscreens) {
        this.systemscreens = sysscreens;
        for (let i = 0; i < sysscreens.length; i++) {
          this.menuparts[sysscreens[i].id] = true;
        }
      } else {
        this.userService.getMenu().subscribe(
          screens => {
            this.systemscreens = screens;
            localStorage.setItem('menu'+this.openSystem,JSON.stringify(screens));
            for (let i = 0; i < screens.length; i++) {
              this.menuparts[screens[i].id] = true;
            }
          }, error => {
            console.log(error);
          }
        );
      }

    }
  }

  ngOnInit(): void {
    if(localStorage.getItem('showMenu')) {
      const showMenu = JSON.parse(localStorage.getItem('showMenu'));
      this.isShow = showMenu;
    }
     this.router.events.subscribe((res) => {
       if(this.openSystem !== '') {
         this.getsystem();
       }
     });
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
    }
    this.getsystem();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar/app-sidebar.component.ts